<!-- <div fxFlex="50" fxFlex.lt-md="100">
        <app-combo-commande [control]="get(fields.pbkStrId)"  [controlFils]="get(fields.bizKindStrId)"
        [label]="fields.finaEvalRate | translate"  [code]="CommmCode.categorieActivite"></app-combo-commande>
      </div> -->
<div class="dialog-headline" fxLayout="row wrap" fxLayoutAlign="space-between start">
    <h2 class="dialog-title" mat-dialog-title>{{'Renouvèlement' | translate}}</h2>
    <button class="dialog-close-btn" mat-dialog-close mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>
<form [formGroup]="form">
    <div mat-dialog-content>
        <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
            <mat-card-header class="titree">
                {{ "N° carte identité" | translate }}
            </mat-card-header>
            <mat-card-content class="card-content">
                <div class="p-3" fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">
                    <app-text-field
                            [control]="get('indRegNo')"
                            [label]="'N° CIN'"
                           
                    ></app-text-field>
                </div>
            </mat-card-content>
        </mat-card>


        <div *ngIf="certiflocalbool" style="margin-top: 3%;
      ">
            <app-spinner-container [isLoading]="ondelete">
                <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
                    <mat-card-content class="card-content">
                        <table

                                [dataSource]="dataSource"
                                mat-table

                                style="width: 100%"
                        >
                            <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
                                <th *matHeaderCellDef mat-header-cell translate>
                                    {{ labels[column] }}
                                </th>
                                <td *matCellDef="let type" mat-cell translate>
                                    {{ type[column]  }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="action">
                                <th *matHeaderCellDef mat-header-cell>{{'Plus de détails' | translate}}</th>
                                <td *matCellDef="let certif" mat-cell>
                                    <a (click)="openCertif(certif)" mat-icon-button>
                                        <mat-icon style="color: #00a8ff;">add_circle</mat-icon>
                                    </a>

                                </td>
                            </ng-container>
                            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                            <tr (click)="selection.toggle(row)" (click)="toggle()" (mouseout)="row.hovered = false"
                                (mouseover)="row.hovered = true"
                                *matRowDef="let row; columns: displayedColumns"
                                [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}" mat-row></tr>
                        </table>
                        <app-empty-list-container [list]="dataSource.data"
                                                  [withoutBorder]="true"></app-empty-list-container>
                    </mat-card-content>
                </mat-card>
            </app-spinner-container>
        </div>
        <div class="mt-2" fxLayoutAlign="end">
            <app-spinner-container>
                <button (click)="onSuccess()" [disabled]="disabled_conn" color="primary" mat-raised-button>
                    <span translate>submit</span>
                </button>
            </app-spinner-container>
        </div>
    </div>
</form>
  
